// extracted by mini-css-extract-plugin
export default {"cardContainer":"firstTab_cardContainer__cierg","card":"firstTab_card__+TB5X","card_body":"firstTab_card_body__13TDa","modal":"firstTab_modal__8L+CK"};